export const SET_DAYS = 'SET_DAYS'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_SELECTED = 'SET_SELECTED'
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const SET_ACCOUNT = 'SET_ACCOUNT'
export const SET_STORAGE = 'SET_STORAGE'
export const SET_BUCKET_CONTENTS = 'SET_BUCKET_CONTENTS'
export const SET_ATTACHED = 'SET_ATTACHED'

export const STORAGE_ORDER_BY = 'storage/orderBy'
export const STORAGE_SORT_DIR = 'storage/sortDir'
export const STORAGE_DAYS = 'storage/days'
export const STORAGE_PAGE_SIZE = 'storage/pageSize'
export const STORAGE_SEARCH_TERM = 'storage/searchTerm'
export const STORAGE_FILTER_BY = 'storage/filterBy'



// WEBPACK FOOTER //
// ./src/store/modules/storage/types.js